import React from 'react';
import { Modal, Spin, Alert } from 'antd';
import {
  LoadingOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { CLEAR_ERRORS } from '../../state/error/types';
import PropTypes from 'prop-types';

const spinnerIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

const ModalSendNotarisa = ({ ...props }) => {
  return (
    <Modal
      visible={props.visible}
      title="Enviar contrato a Notarisa"
      okText="Enviar"
      cancelText="Cancelar"
      maskClosable={false}
      onCancel={props.onCancel}
      afterClose={() => props.clearErrors()}
      onOk={() => props.onCreate()}
      okButtonProps={{ disabled: props.spinning }}
      cancelButtonProps={{ disabled: props.spinning }}
    >
      <Spin
        spinning={props.spinning}
        size="large"
        indicator={spinnerIcon}
        tip="Enviando a Notarisa"
      >
        <Alert
          message="Está a punto de enviar el contrato a Notarisa"
          description="Se enviará el contrato a Notarisa para su revisión y firma notarial. Una vez firmado, el contrato pasará a estado finalizado."
          type="info"
          showIcon
        />
      </Spin>
    </Modal>
  );
};

ModalSendNotarisa.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  spinning: PropTypes.bool.isRequired,
  spinnerIcon: PropTypes.object,
};

const action = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(null, action)(ModalSendNotarisa);